const cryptoCurrencies = {
    Bitcoin: 'BTC',
    Ethereum: 'ETH',
  };
  
export default cryptoCurrencies;
